//Library Imports
import { Popover } from "antd";
import styled from "styled-components";

//Local Imports
import { ReactComponent as Edit } from "assets/img/icons/Edit.svg";
import { ReactComponent as Delete } from "assets/img/icons/ArticlePopover/lowerList/Delete.svg";
import { removeOnClickBubble } from "utils";
import { deleteSalesXGroup } from "../actions";
import { ReactNode } from "react";

interface IMenuPopUp {
  children: ReactNode;
  groupId: number;
  handleOnDelete: () => void;
  isEditable: any;
}
interface IContent {
  groupId: number;
  handleOnDelete?: () => void;
  isEditable: any;
}

const handleOnDelete = (e: React.SyntheticEvent, groupId: number) => {
  removeOnClickBubble(e);
  console.log("Group id: ", groupId);
  console.log("e: ", e);
  deleteSalesXGroup(groupId);
};

const Title = (props: any) => {
  return (
    <PopupTitle className={`${props.isEditable ? "" : ""}`}>
      <div>
        <StyledEdit />
        <label className="edit-text">Edit Group</label>
      </div>
    </PopupTitle>
  );
};

const Content: React.FC<IContent> = (props: any) => {
  const handleClick = (e: React.SyntheticEvent) => {
    removeOnClickBubble(e);
    if (!props.isEditable) return;
    props.handleOnDelete && props.handleOnDelete();
  };
  return (
    <PopupContent className={`${props.isEditable ? "" : "disabled-delete"}`}>
      <div onClick={handleClick}>
        <StyledDelete />
        <label className={`delete-text ${props.isEditable ? "" : "disabled-delete"}`}>Delete Group</label>
      </div>
    </PopupContent>
  );
};

const MenuPopUp: React.FC<IMenuPopUp> = (props) => {
  return (
    <Popover
      content={
        <Content groupId={props.groupId} handleOnDelete={props.handleOnDelete} isEditable={props.isEditable} />
      }
      title={<Title isEditable={props.isEditable} />}
      trigger="click"
      placement="leftTop"
      destroyTooltipOnHide={true}
      overlayClassName={`BlogPopover popover-radius overflow-fix Popover-share`}
    >
      {props.children}
    </Popover>
  );
};

export default MenuPopUp;

const PopupTitle = styled.div`
  font-family: "roboto_regular", sans-serif;
  font-size: 14px;
  color: #27ce0a;
  padding-top: 5px;
  padding-bottom: 5px;
  .edit-text {
    font-family: "Roboto";
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: -0.4px;
    color: #1ec252;
  }
  .edit-text:hover {
    cursor: pointer;
  }
  :hover {
    cursor: pointer;
  }
`;

const PopupContent = styled.div`
  font-family: "roboto_regular", sans-serif;
  font-size: 14px;
  padding-top: 5px;
  padding-bottom: 5px;
  .delete-text {
    font-family: "Roboto";
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: -0.4px;
    color: #7e7e7e;
  }
  .delete-text:hover {
    cursor: pointer;
    &.disabled-delete {
      cursor: not-allowed;
    }
  }
  :hover {
    cursor: pointer;
  }
  &.disabled-delete {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

const StyledEdit = styled(Edit)`
  margin-left: 12px;
  margin-right: 8.82px;
  margin-bottom: 4px;
`;

const StyledDelete = styled(Delete)`
  margin-left: 12px;
  margin-right: 8px;
  margin-bottom: 5px;
`;

MenuPopUp.defaultProps = {
  isEditable: true,
};
